import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { SearchableInputSelect } from '@components/SearchableInputSelect';
import { ResourceState } from '@domain/schemas/contract.schema';
import { useSubmissions } from '@queries/fetchSubmissions';
import { isEmptyValue } from '@root/helpers';
import type { SubmissionShort } from '@src/queries';

import type { StepProps } from '../types';

const filterFinalSubmissions = (item: SubmissionShort) => {
  return !isEmptyValue(item.name) && item.status === ResourceState.FINAL;
};

export const Step0: FC<StepProps> = ({ control, formValues }) => {
  const { data: submissions = [], isLoading: isFetchingSubmissions } = useSubmissions();

  const submissionOptions = submissions.filter(filterFinalSubmissions).map((item) => ({
    name: item.name,
    value: item.id,
  }));

  return (
    <Controller
      control={control}
      render={({ field: { ref: _ref, ...props }, fieldState: { error } }) => (
        <SearchableInputSelect
          {...props}
          errors={error?.message}
          isLoading={isFetchingSubmissions}
          noOptionsLeftLabel="No contracts available"
          labelText="Select a contract to renew"
          placeholder="Search contracts"
          options={submissionOptions}
          value={formValues?.renewFromSubmissionId}
        />
      )}
      name="renewFromSubmissionId"
    />
  );
};
